export enum ReferrerSearchParams {
    Title = "referrer_title",
    URL = "referrer_url",
}

export const getLoginRedirectPath = () => {
    if (globalThis.location.pathname.length > 1) {
        return `/auth/login?${ReferrerSearchParams.URL}=${encodeURIComponent(
          globalThis.location.pathname + globalThis.location.search
        )}`
    }
    return `/auth`
}
